var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',_vm._l((_vm.data.buttons),function(button,index){return _c('CmsButton',{key:index,staticClass:"d-inline",attrs:{"value":button}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }